import { selectChangeMessageForThemes } from '@UI/aside/asideThemes/AsideThemesSelectors';
import { type ContentHref, ContentType } from '@generalTypes/apiTypes';
import { referencedInProHomeCannotUnpublish } from '@newStore/validation/validationRules/referencedInProHomeCannotUnpublish';
import type { EditAsideThemes, FilterableEditComponent } from '@nodeTypeConfig/configTypes';
import { dienstverleningKovKey } from '@store/constants/constants';
import { authorsComponent } from './authorsComponent';
import { curriculumSelectorComponent } from './curriculumSelector';
import { introDescriptionComponent } from './descriptionComponent';
import { proContactsComponent } from './proContactsComponent';
import { proThumbnailComponent } from './proThumbnailComponent';
import { publishComponent } from './publishComponent';
import { titleComponent } from './titleComponent';

export const proThemesComponent: EditAsideThemes = {
  component: 'themes',
  property: 'themes',
  reactComponent: 'AsideThemes',
  label: "Thema's",
  options: {
    referenceFrameHref: `/content/${dienstverleningKovKey}` as ContentHref,
    types: [ContentType.THEME, ContentType.CURRICULUM_THEME, ContentType.CURRICULUM_CLUSTER],
    highlightOldCurrItems: true,
  },
  asideChangeMessageSelector: selectChangeMessageForThemes,
};

export const proDocumentStandardComponents: Array<FilterableEditComponent> = [
  titleComponent,
  introDescriptionComponent,
  {
    ...proThumbnailComponent,
    label: 'Tegelfoto',
    width: 6,
  },
  {
    ...authorsComponent,
    label: 'Themaverantwoordelijke',
  },
  {
    ...publishComponent,
    validations: [...(publishComponent.validations || []), referencedInProHomeCannotUnpublish],
  },
  proThemesComponent,
  curriculumSelectorComponent,
  proContactsComponent,
];
